import React from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem4sm6xs12,
} from '../../../business-components/Grid/Grid'

import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoRecursoFinanceiroList from '../../../business-rules/List/tipoRecursoFinanceiroList'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoRecursosFinanceiros,
    rowPertentePageRecursosFinanceiros,
    setPageInclusaoRecursosFinanceiros,
} from './GarantiasCompRecursosFinanceiros'

import {
    incrementaContRecursosFinanceiros,
    processaRegistrosDefaultIniciaisRecursosFinanceiros,
    processaValoresDefaultIniciaisRecursosFinanceiros,
    calculaTotaisRecursosFinanceiros,
} from './GarantiasServiceRecursosFinanceiros'

import GarantiasFormRecursosFinanceirosItem from './GarantiasFormRecursosFinanceirosItem'



const GarantiasFormRecursosFinanceiros = ({ values, handleChange, setFieldValue, linhaTipoLicenca/*, jsonConfiguracao*/ }) => {

    let tipoRecursoFinanceiroSelecionado = ''

    calculaTotaisRecursosFinanceiros(values)

    useSingleton(async () => {

        values.pageRecursosFinanceiros = obtemPage(values.pageRecursosFinanceirosList, Number.parseInt(values.familiarRecursosFinanceiros))
    })

    salvaPage(values.pageRecursosFinanceiros, values.pageRecursosFinanceirosList, Number.parseInt(values.familiarRecursosFinanceiros))
    
    let indAux = 0

    values.recursosFinanceirosPagination =
        values.recursosFinanceiros
            ?
                values.recursosFinanceiros.filter(item => item.familiar === Number.parseInt(values.familiarRecursosFinanceiros)
                    && !item.idReceitaMensal)
            :
                []



    return (
        <>
            <PanelRadioGroup
                name="familiarRecursosFinanceiros"
                value={Number.parseInt(values.familiarRecursosFinanceiros) || ''}
                onChange={(e) => {
                    values.pageRecursosFinanceiros = obtemPage(values.pageRecursosFinanceirosList, Number.parseInt(e.target.value))
                    handleChange(e)
                }}
                list={values.totalRecursosFinanceiros}
                onBlur={
                    processaRegistrosDefaultIniciaisRecursosFinanceiros(values,
                        Number.parseInt(values.familiarRecursosFinanceiros))
                }
                helpText={HELPTEXT.recursosFinanceirosPanelRadioGroup}
            />
               
            <FieldArray name="recursosFinanceiros">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.recursosFinanceiros?.map((item, ind) => {

                                processaValoresDefaultIniciaisRecursosFinanceiros(item, values)

                                tipoRecursoFinanceiroSelecionado = pesquisaList(tipoRecursoFinanceiroList, 
                                    item.tipoRecursoFinanceiro)

                                return item.familiar === Number.parseInt(values.familiarRecursosFinanceiros) &&
                                !item.idReceitaMensal &&
                                rowPertentePageRecursosFinanceiros(values, indAux++) ? (
                                    <GridItem4sm6xs12
                                        key={ind}
                                    >
                                        <GarantiasFormRecursosFinanceirosItem
                                            values={values}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            arrayHelpers={arrayHelpers}
                                            linhaTipoLicenca={linhaTipoLicenca}
                                            tipoRecursoFinanceiroSelecionado={
                                                tipoRecursoFinanceiroSelecionado
                                            }
                                            item={item}
                                            ind={ind}
                                            //jsonConfiguracao={jsonConfiguracao}
                                            simplificado={false}
                                        />
                                    </GridItem4sm6xs12>
                                )
                                :
                                (
                                   ''
                                )
                            })}
                        </GridContainer>

                        <TablePaginationPadraoRecursosFinanceiros
                            values={values}
                            setFieldValue={setFieldValue}
                        />

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirRecursosFinanceiros} 
                            disabled={familiaresList(values).length === 0 || !values.familiarRecursosFinanceiros ? true : false}
                            onClick={() => 
                                {
                                    incrementaContRecursosFinanceiros(values)
                                    arrayHelpers.push({
                                        id: values.contRecursosFinanceiros,
                                        familiar: Number.parseInt(values.familiarRecursosFinanceiros)
                                    })
                                    setPageInclusaoRecursosFinanceiros(values, setFieldValue)
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </>
    )
}

export default GarantiasFormRecursosFinanceiros